import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { store } from '../../../configureStore';
import orm from '../../../orm';
import { getPanoNavNodeIdFromPanoScene } from './getPanoNavNodeIdFromPanoScene';

import { useDispatch } from 'react-redux';
import { appShowWebNavigationBarSelector } from '../../app/selectors';
import { app_updateStore } from '../../app/slice';
import NavBarComponent from '../../navNode/NavBarComponent';

const DEBUG = true;
const debugLog = (msg: string) => {
  if (DEBUG) {
    console.log(msg);
  }
};

type Props = {
  navNodeId: string;
};

const PanoComponent: React.FC<Props> = (props: Props) => {
  debugLog('Component: PanoComponent with props: ' + JSON.stringify(props, null, 4));

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { navNodeId } = props;

  const session = orm.session(store.getState().orm);
  const { Experience, NavNode, Pano } = session;

  // @ts-ignore
  const navNode = NavNode.withId(navNodeId);
  const contentId = navNode.contentId;

  const experienceId = navNode.experienceId;
  // @ts-ignore
  const experience = Experience.withId(experienceId);

  // @ts-ignore
  const pano = Pano.withId(contentId);

  // const [receivedMessage, setReceivedMessage] = useState('');
  const iframeRef = useRef(null);

  useEffect(() => {
    // Function to handle messages received from the iframe
    const handleMessage = (event: any) => {
      const name = (JSON.parse(event.data).name);
      // setReceivedMessage(JSON.parse(event.data).name);
      const panoNavNodeId = getPanoNavNodeIdFromPanoScene(event.data);
      // @ts-ignore
      const panoNavNode = NavNode.withId(panoNavNodeId);

      dispatch(app_updateStore({ key: 'nnHash', value: panoNavNodeId }));
      dispatch(app_updateStore({ key: 'title', value: name }));

      const panoPageURL = `${process.env.REACT_APP_BASENAME}/#nn=${panoNavNodeId}`;

      navigate(panoPageURL, { replace: true });

      // this results in multiple history entries
      // navigate(panoPageURL, { replace: false });
      console.log(navigate)
      // TODO:
      // should we replace iframe with object ?
      // !!! History is not available in iframe ? and in react-router-dom v7
      // history.push(panoPag`eURL);
    };

    // Add the event listener when the component mounts
    window.addEventListener('message', handleMessage);

    // Clean up the event listener when the component unmounts
    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, []); // Empty dependency array means this runs once on mount and cleanup on unmount



  const externalUrlToPano = `${process.env.REACT_APP_EXPERIENCE_CONTENT_BASE_URL}/${pano.tourHtmlFilePath}`;
  const externalUrlToPanoStartScene = `${externalUrlToPano}?startscene=${navNode.panoVersionStartSceneSlug}`;

  const showWebNavigationBar = appShowWebNavigationBarSelector(store.getState());
  return (

    // <div style={{ display: 'flex', flexGrow: 1 }}>
    //   <object
    //     ref={iframeRef}
    //     data={externalUrlToPanoStartScene}
    //     width={window.innerWidth}
    //     height={showWebNavigationBar ? window.innerHeight - constants.NAVBAR_HEIGHT * window.innerHeight : window.innerHeight}
    //   >
    //   </object>
    // </div>

    
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      height: window.innerHeight,
      width: window.innerWidth,
      // border: '1px solid red',
    }}>

      <div style={{
        flexGrow: 0,
        // border: '1px solid green',
      }}>
      { showWebNavigationBar &&
        <NavBarComponent navNodeId={navNodeId} showBrandNameSettings={false} showGoBack={false} showSettings={false} showSharing={false} title={''} />
      }
      </div>

      <iframe
        id="iFrameExample"
        title="iFrame Example"
        src={`${externalUrlToPanoStartScene}`}
        width={window.innerWidth}
        style={{
          flexGrow: 1,
        }}
      >
      </iframe>

    </div>



  );
};

export default PanoComponent;
